import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLeaveList,
  createLeaveEntry,
  getLeaveEntryById,
  updateLeaveEntry,
  checkDeleteLeaveEntry,
  deleteLeaveEntry
} from "./LeaveApprovalActions";

const initialState = {
  leaveEntryData: [],
  selectedLeaveEntry: null,
  deleteMessage: "",
   meta: {
        totalRecords:0,
        totalPages:0,
        CurrentPage:1,
        pageSize:5,
    },
  loading: false,
  error: null,
};

const leaveEntrySlice = createSlice({
  name: "leaveEntry",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(fetchLeaveList.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchLeaveList.fulfilled, (state, action) => {
        state.loading = false;
        // state.leaveEntryData = action.payload.data;
        const list = action.payload?.data?.data || [];

        // const leaveEntryData = paged?.data || [];

        state.leaveEntryData = Array.isArray(list) ? list : [];

        const meta = list.length > 0 ? list[0] : {}
        state.meta = {
          totalRecords:meta.totalRecords ?? 0,
          totalPages: meta.totalPages ?? 0,
          CurrentPage: meta.CurrentPage ?? 0,
          pageSize: meta.pageSize ?? 0,
        }
      })

      .addCase(fetchLeaveList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data;
      })
      .addCase(createLeaveEntry.pending, (state) => {
        state.loading = true;
      })

      .addCase(createLeaveEntry.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveEntryData = action.payload.data;
      })

      .addCase(createLeaveEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLeaveEntryById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLeaveEntryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedLeaveEntry = action.payload.data[0];
      })
      .addCase(getLeaveEntryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(updateLeaveEntry.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateLeaveEntry.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedLeaveEntry = action.payload.data;
      })
      .addCase(updateLeaveEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(checkDeleteLeaveEntry.pending, (state) => {
  state.loading = true;
})

.addCase(checkDeleteLeaveEntry.fulfilled, (state, action) => {
  state.loading = false;
  state.deleteMessage = action.payload.message;
})

.addCase(checkDeleteLeaveEntry.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})
.addCase(deleteLeaveEntry.pending, (state) => {
  state.loading = true;
})

.addCase(deleteLeaveEntry.fulfilled, (state, action) => {
  state.loading = false;
  state.deleteMessage = action.payload.message;
})

.addCase(deleteLeaveEntry.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})

  },
});

export default leaveEntrySlice.reducer;
